import React from 'react'
import { CardBody, Col, Container, Row,Card } from 'reactstrap'
import caspLogo from "../../assets/images/casp-main-logo.png";
import { TextField } from "@mui/material";
import frame from "../../assets/images/frame.png"

export const ProjectRegister = () => {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center w-100 h-screen">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6}>
                            <Card className='register mt-5'>
                                <CardBody>
                                    <div className='d-flex justify-content-center mt-2'>
                                        <img src={caspLogo} alt="" height="50" />
                                    </div>
                                    <div className="text-center mt-2">
                                        <h5 className="mt-4">Welcome to XYZ Project</h5>
                                    </div>
                                    <div className='d-flex justify-content-center mt-3'>
                                        <img src={frame} alt="" />
                                    </div>
                                    <div className='d-flex justify-content-center mt-2'>
                                        <p>Upload Picture Photo</p>
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                        <p>Drop your file here or <a style={{ color: "blue" }}>Browse</a></p>
                                    </div>
                                    <div className="mt-5 text">
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Enter Password"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </div>
                                    <div className="mt-2 text">
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Confirm Password"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </div>
                                    <div className='mt-3' style={{ width: "100%" }}>
                                        <button className="create_register w-100  py-2">Register</button>
                                    </div>
                                </CardBody>

                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </>

    )
}

export default ProjectRegister


